import axios, { AxiosRequestConfig } from 'axios';

export function createClient(options: AxiosRequestConfig) {
  return axios.create(options);
}
